import React, {useEffect, useState} from 'react';
import { Form, Space } from 'antd';
import SPSelectWithEnum from "../../../base/SPSelectWithEnum";
const USED = 1
interface PropsType {
    enums: any
}

const ParkingFee: React.FC<PropsType> = (props) => {
    const { enums } = props
    const form = Form.useFormInstance();

    const [ needDepreciate, setNeedDepreciate ] = useState<any>('')
    const onDepreciateChange = (e: any) => {
        setNeedDepreciate(e)
    }

    useEffect(() => {
        setNeedDepreciate(form?.getFieldValue(['outage', 'used']))
    }, [form?.getFieldValue(['outage', 'used'])]);
    return (
        <>
            <Form.Item noStyle name={['outage', 'used']}  style={{
                width: '300px' }}>
                <SPSelectWithEnum style={{
                    width: '300px' }} onChange={onDepreciateChange} enums={enums} enumKey={'is_used'}
                ></SPSelectWithEnum>
            </Form.Item>
            <div  style={{
                width: '500px' }}>
                {
                    needDepreciate === USED ?
                        <>
                            对于因车辆事故，或因驾车过程中操作不当造成的车辆故障等影响车辆正常营运，将收取停运损失费
                            <div>
                                根据车辆所需维修时段，按维修时段实时费用（包含基本保险，但不包含手续费及附加服务费）的
                                <Form.Item noStyle style={{display: 'inline-block'}} name={['outage', 'percent']} rules={[{ required: true, message: '请选择' }]}>
                                    <SPSelectWithEnum  style={{
                                        width: '100px' }} enums={enums} enumKey={'f_parking_service_percentage'}
                                    ></SPSelectWithEnum>
                                </Form.Item>收取车辆停运损失费
                            </div>

                        </>
                        : <></>
                }
            </div>
        </>
    )
}

export default ParkingFee;


